import { simulator } from "./simulator";

// Stand-in for the socket.io client. Implements the slice of the Socket API
// the app uses: on, off (with or without a handler), emit, disconnect.
// Client emits go to the simulator; the simulator delivers server events back
// through deliver().

type Handler = (...args: any[]) => void;

export class MockSocket {
  private handlers = new Map<string, Set<Handler>>();
  connected = false;
  private closed = false;

  constructor() {
    // Fire "connect" asynchronously: the app's contexts attach their
    // listeners on the render after the socket is stored in state.
    setTimeout(() => {
      if (this.closed) return;
      this.connected = true;
      simulator.attach(this);
      this.deliver("connect");
    }, 60);
  }

  on(event: string, fn: Handler) {
    if (!this.handlers.has(event)) this.handlers.set(event, new Set());
    this.handlers.get(event)!.add(fn);
    return this;
  }

  off(event: string, fn?: Handler) {
    if (!fn) this.handlers.delete(event);
    else this.handlers.get(event)?.delete(fn);
    return this;
  }

  emit(event: string, ...args: any[]) {
    if (this.closed) return this;
    // Mirror the network: never handle synchronously inside the caller.
    setTimeout(() => {
      if (!this.closed) simulator.handle(event, args[0]);
    }, 0);
    return this;
  }

  /** Server → client. */
  deliver(event: string, payload?: any) {
    if (this.closed) return;
    const set = this.handlers.get(event);
    if (!set) return;
    Array.from(set).forEach((fn) => {
      try {
        fn(payload);
      } catch (e) {
        console.error(`[sandbox] handler for ${event} threw`, e);
      }
    });
  }

  disconnect() {
    this.closed = true;
    this.connected = false;
    simulator.detach(this);
    this.handlers.clear();
    return this;
  }
}
